const React = require('react');
const ReactRedux = require('react-redux');
const createReactClass = require('create-react-class');

const StepMenu = require('../components/StepMenu.jsx');
const TargetRelease = require('./TargetRelease.jsx');
const TargetReleaseRO = require('./TargetReleaseRO.jsx');

const Approval = require('./Approval.jsx');
const ApprovalRO = require('./ApprovalRO.jsx');
const Deployment = require('./Deployment.jsx');
const DeployPlan = require('./DeployPlan.jsx');
const DeployPlanRO = require('./DeployPlanRO.jsx');
const Modal = require('../Modal.jsx');
const LoadingBar = require('../components/LoadingBar.jsx');

const actions = require('../_actions.js');
const constants = require('../constants/deployment.js');
const favicons = require('../favicons.js');

const moment = require('moment-timezone');

function calculateSteps(props) {
	return [
		{
			title: "Target release",
			show: props.show[0],
			is_finished: props.is_finished[0],
			is_skipped: props.is_skipped[0],
			is_failed: props.is_failed[0]
		},
		{
			title: "Deployment plan",
			show: props.show[1],
			is_finished: props.is_finished[1],
			is_skipped: props.is_skipped[1],
			is_failed: props.is_failed[1]
		},
		{
			title: "Approval",
			show: props.show[2],
			is_finished: props.is_finished[2],
			is_skipped: props.is_skipped[2],
			is_failed: props.is_failed[2]
		},
		{
			title: "Deployment",
			show: props.show[3],
			is_finished: props.is_finished[3],
			is_skipped: props.is_skipped[3],
			is_failed: props.is_failed[3]
		}
	];
}

const DeployModal = createReactClass({

	componentDidMount: function() {
		window.addEventListener("resize", this.resize);
		const {theme, state} = this.props;
		const bodyElements = document.getElementsByClassName("modal-body");
		if (bodyElements.length === 0) {
			return;
		}

		this.resize();
		this.attachEscapeKey();
		favicons.updateFavicon(theme, state);
	},

	componentWillUpdate: function() {
		// Before we update, we save the current scroll "position" for use in componentDidUpdate
		this.saveScrollPosition();
	},

	componentDidUpdate: function(prevProps) {
		this.resize();
		// when the layout changes from write to readonly we ensure that the modal is scrolled to the same position
		// relative to the bottom to prevent a jarring jump. This happens when sending for approval or bypassing the
		// approval step.
		if (prevProps.can_edit !== this.props.can_edit) {
			this.resumeScrollPosition();
		}

		if (this.props.state !== prevProps.state) {
			favicons.updateFavicon(this.props.theme, this.props.state);
		}
	},

	componentWillUnmount: function() {
		window.removeEventListener("resize", this.resize);
	},

	/**
	 * Used as a middle-step function to pass the theme prop into the close action
	 */
	onCloseModal() {
		this.props.onClose(this.props.theme);
	},

	/**
	 * Add a listener to the document to close the modal when the escape key is pressed
	 */
	attachEscapeKey() {
		$(document).keyup((e) => {
			// 27 is the esc key
			if (e.keyCode === 27) {
				this.props.onClose(this.props.theme);
			}
		});
	},

	bodyElement: null,

	// calculate and set a pixel value on the modal height instead of a percentage
	// value so that we get a scrollbar inside the body of the modal
	resize: function() {
		// We need to calculate the height of the ".modal .body" in the browsers window
		let headerHeight = 0;
		const headerElements = document.getElementsByClassName("modal-header");
		if (headerElements.length > 0) {
			headerHeight = headerElements[0].offsetHeight;
		}
		const bodyElements = document.getElementsByClassName("modal-body");
		let bodyHeight = 0;
		if (bodyElements.length > 0) {
			// leave 60px of space to the bottom of the window
			bodyHeight = (window.innerHeight - headerHeight) - 60;
		}

		if (bodyHeight === 0) {
			return;
		}

		// Increase the height of the modal, this cannot be done reliable in CSS because
		// a pixel value is required to use the "sticky" side bar
		bodyElements[0].style.height = bodyHeight + 'px';
	},

	scrollHeight: 0,

	scrollTop: 0,

	// save the current scroll position
	saveScrollPosition() {
		const node = document.getElementsByClassName("modal-body");
		if (node.length > 0) {
			this.scrollHeight = node[0].scrollHeight;
			this.scrollTop = node[0].scrollTop;
		}
	},

	// scroll the modal window body to the position previously saved in saveScrollPosition() relative
	// to the bottom. This will prevent the content jumping if content above the current scroll position
	// changes height.
	resumeScrollPosition() {
		const node = document.getElementsByClassName("modal-body");
		if (node.length > 0) {
			node[0].scrollTop = this.scrollTop + (node[0].scrollHeight - this.scrollHeight);
		}
	},

	render: function() {
		const steps = calculateSteps(this.props);
		const content = [];

		content[0] = (
			<div key={0} className="section">
				<LoadingBar show />
			</div>
		);

		if (steps[0].show) {
			if (this.props.can_edit) {
				content[0] = (<TargetRelease key={0} />);
			} else {
				content[0] = (<TargetReleaseRO key={0} />);
			}
		}
		if (steps[1].show) {
			if (this.props.can_edit) {
				content[1] = (<DeployPlan key={1} />);
			} else {
				content[1] = (<DeployPlanRO key={1} />);
			}
		}
		if (steps[2].show) {
			if (this.props.can_edit) {
				content[2] = (<Approval key={2} />);
			} else {
				content[2] = (<ApprovalRO key={2} />);
			}
		}
		if (steps[3].show) {
			content[3] = (<Deployment key={3} />);
		}

		const options = [];
		if (this.props.deployment_id && this.props.can_delete) {
			options.push({
				title: 'Delete',
				icon: 'fa fa-trash',
				handler: this.props.onDelete
			});
		}

		if (this.props.deployment_id && this.props.deployment.package_id) {
			options.push({
				title: 'Copy deployment',
				icon: 'fa fa-retweet',
				handler: this.props.onDuplicate
			});
		}

		let stateHeaderText = null;
		switch (this.props.state) {
			case constants.STATE_COMPLETED: {
				stateHeaderText = <span> completed on {this.props.date_started.format('DD/MM/YYYY h:mma')}</span>;
				break;
			}
			case constants.STATE_FAILED: {
				stateHeaderText = <span> failed at {this.props.date_started.format('DD/MM/YYYY h:mma')}</span>;
				break;
			}
			case constants.STATE_REJECTED: {
				stateHeaderText = <span> has been rejected</span>;
				break;
			}
			case constants.STATE_APPROVED: {
				stateHeaderText = <span> is ready</span>;
				break;
			}
			case constants.STATE_QUEUED:
			case constants.STATE_DEPLOYING: {
				stateHeaderText = <span> in progress...</span>;
				break;
			}
			case constants.STATE_SUBMITTED:
				stateHeaderText = <span> is awaiting approval</span>;
				break;
			default:
				stateHeaderText = '';
		}

		let lockIcon = null;
		if (this.props.deployment.locked_by) {
			lockIcon = <i className="fa fa-lock"></i>;
		}
		const modalTitle = (
			<span>
				{lockIcon} Deploy to {this.props.project_name} / {this.props.environment_name}{stateHeaderText}
			</span>
		);

		return (
			<Modal
				className={"deploy status-" + this.props.state}
				closeHandler={this.onCloseModal}
				title={modalTitle}
				closeTitle="Close"
				options={options}
				large={true}
			>
				<div>
					<div className="menu affix">
						<StepMenu steps={steps} />
					</div>
					<div className="main">
						<div className="deploy-form">
							<div>
								{content}
							</div>
						</div>
					</div>
				</div>
			</Modal>
		);
	}
});

const mapStateToProps = function(state) {
	function deployPlanIsOk() {
		return state.plan.validation_code === 'success' || state.plan.validation_code === 'warning';
	}

	const current = state.deployment.list[state.deployment.current_id] || {};

	const showPlan = state.git.selected_release !== "" && (typeof state.plan.changes === "object");
	const showApproval = state.deployment.current_id !== "" && current.dirty === false;

	return {
		show: [
			(!state.git.is_loading && !state.git.is_fetching && !state.deployment.is_loading),
			showPlan,
			showPlan && showApproval,
			constants.isApproved(current.state)
		],
		is_finished: [
			deployPlanIsOk() && state.git.selected_release !== "",
			deployPlanIsOk() && state.deployment.current_id !== "",
			deployPlanIsOk() && constants.isApproved(current.state),
			constants.isDeployDone(current.state)
		],
		is_skipped: [
			false,
			state.plan.summary_of_changes === "" && state.plan.title === "",
			current.approver == null,
			false
		],
		is_failed: [
			false,
			false,
			false,
			constants.isDeployFailed(current.state)
		],
		can_edit: constants.canEdit(state),
		can_delete: constants.canDelete(state),
		state: current.state,
		environment_name: state.environment.name,
		project_name: state.environment.project_name,
		deployment_id: state.deployment.current_id,
		deployment: current,
		date_started: moment.unix(current.date_started_unix).tz(state.user.timezone),
		theme: state.user.theme
	};
};

const mapDispatchToProps = function(dispatch) {
	return {
		onClose: function(theme) {
			actions.history.push('/');
			favicons.updateFavicon(theme);
		},
		onDelete: function() {
			dispatch(actions.deleteDeployment())
				.then(() => actions.history.push('/'));
		},
		onDuplicate: function() {
			let location = window.location.href;
			location = location.replace('overview/deployment', 'deploys/duplicate');
			window.location.href = location;
		}
	};
};

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(DeployModal);
